import { Link } from 'react-router-dom'
import { 
  PhoneIcon, 
  EnvelopeIcon, 
  MapPinIcon
} from '@heroicons/react/24/outline'
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon
} from '../icons/SocialIcons'
import logo from '../../images/web-logo.jpeg'

const contactInfo = {
  office: '703-373-2564',
  fax: '703-373-2565',
  mobile: '540-615-2418',
  email: 'aplusavadrivingschool@gmail.com',
  address: '10 Wellington Drive, Stafford, VA 22554',
}

const quickLinks = [
  { href: '/', label: 'Home' },
  { href: '/courses', label: 'Courses' },
  { href: '/register', label: 'Register' },
  { href: '/pay-online', label: 'Pay Online' },
  { href: '/reviews', label: 'Reviews' },
  { href: '/faq', label: 'FAQ' },
  { href: '/contact', label: 'Contact' },
]

const legalLinks = [
  { href: '/privacy-policy', label: 'Privacy Policy' },
  { href: '/terms-conditions', label: 'Terms & Conditions' },
  { href: '/refund-policy', label: 'Refund Policy' },
]

export default function Footer() {
  return (
    <footer className="bg-primary text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={logo} 
                alt="A Plus A Driving School Logo" 
                className="w-12 h-12 sm:w-14 sm:h-14 object-contain rounded-full"
              />
              <div>
                <div className="font-heading font-bold text-base sm:text-lg">A Plus A</div>
                <div className="font-heading text-xs sm:text-sm">Driving School</div>
              </div>
            </div>
            <p className="text-xs sm:text-sm text-gray-300 mb-4">
              Your trusted partner for safe driving education. Licensed and certified driving school serving VA and surrounding areas.
            </p>
            <div className="flex gap-3 flex-wrap">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-accent hover:border-accent hover:text-primary transition-colors" aria-label="Facebook">
                <FacebookIcon className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-accent hover:border-accent hover:text-primary transition-colors" aria-label="Instagram">
                <InstagramIcon className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-accent hover:border-accent hover:text-primary transition-colors" aria-label="Twitter">
                <TwitterIcon className="w-5 h-5" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-accent hover:border-accent hover:text-primary transition-colors" aria-label="YouTube">
                <YoutubeIcon className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-bold text-base sm:text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-300 hover:text-accent transition-colors text-xs sm:text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="font-heading font-bold text-base sm:text-lg mb-4">Contact Us</h3>
            <ul className="space-y-3 text-xs sm:text-sm text-gray-300">
              <li className="flex items-start gap-2">
                <PhoneIcon className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <div>
                  <div>Office: <a href={`tel:${contactInfo.office}`} className="hover:text-accent">{contactInfo.office}</a></div>
                  <div>Fax: {contactInfo.fax}</div>
                  <div>Mobile: <a href={`tel:${contactInfo.mobile}`} className="hover:text-accent">{contactInfo.mobile}</a></div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <EnvelopeIcon className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-accent break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPinIcon className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="font-heading font-bold text-base sm:text-lg mb-4">Business Hours</h3>
            <ul className="space-y-2 text-xs sm:text-sm text-gray-300 mb-4">
              <li>
                <span className="font-semibold">Monday - Friday:</span> 9:00 AM - 6:00 PM
              </li>
              <li>
                <span className="font-semibold">Saturday - Sunday:</span> 9:00 AM - 4:00 PM
              </li>
              {/* <li>
                <span className="font-semibold">Sunday:</span> Closed
              </li> */}
            </ul>
            <div className="bg-primary/80 rounded-lg p-3 border border-accent/20">
              <div className="text-accent font-heading font-semibold text-xs sm:text-sm mb-1">DMV Licensed</div>
              <div className="text-xs text-gray-300">Serving Virginia since 2010</div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 mt-8 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 text-xs sm:text-sm text-gray-300 text-center sm:text-left">
            <div>© 2026 A Plus A Driving School. All rights reserved.</div>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
              {legalLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="hover:text-accent transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

